import React, { forwardRef, ReactNode, Ref, RefObject, useState } from 'react';

export interface TripRouteAccordionGroupProps {
  /** The content inside the accordion group */
  children: ReactNode[];
  /** The reference for the container */
  ref?: RefObject<HTMLDivElement>;
}

const TripRouteAccordionGroup = forwardRef<
  HTMLDivElement,
  TripRouteAccordionGroupProps
>(({ children }, ref: Ref<HTMLDivElement>) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div ref={ref}>
      {children.map((child, childIndex) =>
        React.cloneElement(child as React.ReactElement, {
          isActive: activeIndex === childIndex,
          itemIndex: childIndex,
          onClick: () => handleToggle(childIndex),
        }),
      )}
    </div>
  );
});

TripRouteAccordionGroup.displayName = 'TripRouteAccordionGroup';

export default TripRouteAccordionGroup;
